import { render } from "./TRTPatientCard.vue?vue&type=template&id=77b84e60&scoped=true"
import script from "./TRTPatientCard.vue?vue&type=script&lang=js"
export * from "./TRTPatientCard.vue?vue&type=script&lang=js"

import "./TRTPatientCard.vue?vue&type=style&index=0&id=77b84e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b84e60"]])

export default __exports__